// pages/tasks/hooks/useTaskModals.ts
import { useCallback, useState } from "react";
import { Task } from "@/types";

export const useTaskModals = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showAddClientModal, setShowAddClientModal] = useState(false);
  const [showEndDayModal, setShowEndDayModal] = useState(false);
  const [showQuotationPanel, setShowQuotationPanel] = useState(false);
  const [modal, setModal] = useState<{ type: string; task?: Task | null }>({
    type: "",
    task: null,
  });

  const openModal = useCallback((type: string, task: Task) => {
    setModal({ type, task });
  }, []);

  const closeModal = useCallback(() => {
    setModal({ type: "", task: null });
  }, []);

  return {
    showAddModal,
    setShowAddModal,
    showAddClientModal,
    setShowAddClientModal,
    showEndDayModal,
    setShowEndDayModal,
    showQuotationPanel,
    setShowQuotationPanel,
    modal,
    openModal,
    closeModal,
  };
};